import circular from './components/circular';
import nineLucky from './components/nineLucky';
export default {
  name: 'lottery',
  components: {
    circular,
    nineLucky
  },
  data() {
    return {};
  }
};